import { FC } from 'react';
import { useDoApprove, useQueryApproval } from '../common/ActionForm';
import { useDoRepay } from './RepayForm';
import { RepayPanel } from './RepayPanel';

export const RepayPanelController: FC = () => {
  const queryApproval = useQueryApproval();
  const doApprove = useDoApprove();
  const doRepay = useDoRepay();

  return <RepayPanel queryApproval={queryApproval} doApprove={doApprove} doRepay={doRepay} />;
};
